/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	// config
	var $window = $(window);
	var breakPoint = 767;
	var resizeFlg = false;
	var windowWidth = $window.width();
	
	$(window).load(function () {
		//	$("#ticket section .detail").tile(2);
		// loading();
		animation();
	});
	function animation() {
		$('h1').delay(100).animate({
			opacity: '1'
		}, 1000);
		setTimeout(function () {
			$('#idx-main .catchcopy').css({
				opacity: '1',
				transform: 'translate(0,0)'
			});
		}, 1500);
	}
	
	// $(function(){
	//   var topBtn = $('.to-top');
	//   topBtn.hide();
	//   $(window).scroll(function () {
	//     if ($(this).scrollTop() > 100) {
	//       topBtn.fadeIn();
	//     } else {
	//       topBtn.fadeOut();
	//     }
	//   });
	// });
	
	$('a[href^=#]').click(function () {
		var speed = 1001;
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({ scrollTop: position }, speed, "swing");
		return false;
	});
	
	$(function () {
		// tile exec
		// if (windowWidth > breakPoint) {
		//   $('.nicocas-list li .info').tile(3);
		// } else {
		//   $('.nicocas-list li .info').tile(2);
		// }
	
		// SP跳ね返り処理時に下が見えてしまう対策
		if (windowWidth > breakPoint) {
			// PCはなにもしない
		} else {
			$(window).scroll(function () {
				var t_position = $('#idx-tsubucon').offset().top;
				var position = $(window).scrollTop();
				if (position > t_position) {
					$('#idx-main').hide();
					$('body').css('background', '#000');
				} else {
					$('#idx-main').css('display', 'block');
					$('body').css('background', 'none');
				}
			});
		}
	});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.bundle.js